import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import PackageService from "../../services/package.service";

/* =================== Thunks =================== */

export const getpackage = createAsyncThunk(
  "package/getpackage",
  async (params, thunkAPI) => {
    try {
      const response = await PackageService.getpackage(params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addpackage = createAsyncThunk(
  "package/addpackage",
  async (data, thunkAPI) => {
    try {
      const response = await PackageService.addpackage(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


export const editpackage = createAsyncThunk(
  "package/editpackage",
  async (data, thunkAPI) => {
    try {
      const response = await PackageService.editpackage(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addoptions = createAsyncThunk(
  "package/addoptions",
  async (data, thunkAPI) => {
    try {
      const response = await PackageService.addoptions(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const editoptions = createAsyncThunk(
  "package/editoptions",
  async (data, thunkAPI) => {
    try {
      const response = await PackageService.editoptions(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);



export const getoptions = createAsyncThunk(
  "package/getoptions",
  async (params, thunkAPI) => {
    try {
      const response = await PackageService.getoptions(params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);
export const addDayPlan = createAsyncThunk(
  "package/addDayPlan",
  async (data, thunkAPI) => {
    try {
      const response = await PackageService.addDayPlan(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const editDayPlan = createAsyncThunk(
  "package/editDayPlan",
  async (data, thunkAPI) => {
    try {
      const response = await PackageService.editDayPlan(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


export const getDayPlan = createAsyncThunk(
  "package/getDayPlan",
  async (data, thunkAPI) => {
    try {
      const response = await PackageService.getDayPlan(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addDayHotel = createAsyncThunk(
  "package/addDayHotel",
  async (data, thunkAPI) => {
    try {
      const response = await PackageService.addDayHotel(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const editDayHotel = createAsyncThunk(
  "package/editDayHotel",
  async (data, thunkAPI) => {
    try {
      const response = await PackageService.editDayHotel(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addDayVehicle = createAsyncThunk(
  "package/addDayVehicle",
  async (data, thunkAPI) => {
    try {
      const response = await PackageService.addDayVehicle(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const editDayVehicle = createAsyncThunk(
  "package/editDayVehicle",
  async (data, thunkAPI) => {
    try {
      const response = await PackageService.editDayVehicle(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addDayFerry = createAsyncThunk(
  "package/addDayFerry",
  async (data, thunkAPI) => {
    try {
      const response = await PackageService.addDayFerry(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const editDayFerry = createAsyncThunk(
  "package/editDayFerry",
  async (data, thunkAPI) => {
    try {
      const response = await PackageService.editDayFerry(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const deleteDayFerry = createAsyncThunk(
  "package/deleteDayFerry",
  async (id, thunkAPI) => {
    try {
      await PackageService.deleteDayFerry(id);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


export const addDayActivity = createAsyncThunk(
  "package/addDayActivity",
  async (data, thunkAPI) => {
    try {
      const response = await PackageService.addDayActivity(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const editDayActivity = createAsyncThunk(
  "package/editDayActivity",
  async (data, thunkAPI) => {
    try {
      const response = await PackageService.editDayActivity(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


export const deleteDayActivity = createAsyncThunk(
  "package/deleteDayActivity",
  async (id, thunkAPI) => {
    try {
      await PackageService.deleteDayActivity(id);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);



export const calculatePackageOption = createAsyncThunk(
  "package/calculatePackageOption",
  async (data, thunkAPI) => {
    try {
      const response = await PackageService.calculatePackageOption(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const updatepackage = createAsyncThunk(
  "package/updatepackage",
  async (payload, thunkAPI) => {
    try {
      const response = await PackageService.editpackage(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const deletepackage = createAsyncThunk(
  "package/deletepackage",
  async (id, thunkAPI) => {
    try {
      await PackageService.deletepackage(id);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


export const deleteoptions = createAsyncThunk(
  "package/deleteoptions",
  async (id, thunkAPI) => {
    try {
      await PackageService.deleteoptions(id);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const initialState = {
  loading: false,
  error: null,

  packageList: [],
  pages: 1,

  optionList: [],
  dayPlans: [],
  calculation: null,

  updateSuccess: false,
};

const packageSlice = createSlice({
  name: "package",
  initialState,

  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
  },

  extraReducers: (builder) => {

    builder
      .addCase(getpackage.pending, (state) => {
        state.loading = true;
      })
      .addCase(getpackage.fulfilled, (state, action) => {
        state.loading = false;

        state.packageList =
          action.payload?.packages ||
          action.payload?.data ||
          [];

        state.pages =
          action.payload?.pages ||
          action.payload?.totalPages ||
          action.payload?.pagination?.pages ||
          1;
      })
      .addCase(getpackage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(addpackage.pending, (state) => {
        state.loading = true;
      })
      .addCase(addpackage.fulfilled, (state, action) => {
        state.loading = false;

        const pkg =
          action.payload?.data ||
          action.payload?.package ||
          action.payload;

        if (
          !Array.isArray(
            state.packageList
          )
        ) {

          state.packageList = [];
        }

        if (pkg) {

          state.packageList.unshift(
            pkg
          );
        }
      })
      .addCase(addpackage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(getoptions.pending, (state) => {
        state.loading = true;
      })
      .addCase(getoptions.fulfilled, (state, action) => {
        state.loading = false;
        state.optionList =
          action.payload?.data ||
          action.payload?.options ||
          [];
      })
      .addCase(getoptions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(addoptions.pending, (state) => {
        state.loading = true;
      })
      .addCase(addoptions.fulfilled, (state, action) => {
        state.loading = false;

        const option = action.payload?.data;
        if (option) state.optionList.unshift(option);
      })
      .addCase(addoptions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });


    builder
      .addCase(getDayPlan.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDayPlan.fulfilled, (state, action) => {
        state.loading = false;
        state.dayPlans =
          action.payload?.data ||
          action.payload?.dayPlans ||
          [];
      })
      .addCase(getDayPlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(addDayPlan.fulfilled, (state, action) => {
        const day = action.payload?.data;
        if (day) state.dayPlans.push(day);
      });

    builder.addCase(addDayHotel.fulfilled, (state, action) => {
      const updatedDay = action.payload?.data;

      if (!updatedDay) return;

      const index = state.dayPlans.findIndex(
        (d) => d._id === updatedDay._id
      );

      if (index !== -1) {
        state.dayPlans[index] = updatedDay;
      }
    });

    builder.addCase(addDayVehicle.fulfilled, (state, action) => {
      const updatedDay = action.payload?.data;

      const index = state.dayPlans.findIndex(
        (d) => d._id === updatedDay?._id
      );

      if (index !== -1) {
        state.dayPlans[index] = updatedDay;
      }
    });

    builder.addCase(addDayFerry.fulfilled, (state, action) => {
      const updatedDay = action.payload?.data;

      const index = state.dayPlans.findIndex(
        (d) => d._id === updatedDay?._id
      );

      if (index !== -1) {
        state.dayPlans[index] = updatedDay;
      }
    });

    builder.addCase(deleteDayFerry.fulfilled, (state, action) => {
      const updatedDay = action.payload?.data;

      const index = state.dayPlans.findIndex(
        (d) => d._id === updatedDay?._id
      );

      if (index !== -1) {
        state.dayPlans[index] = updatedDay;
      }
    });

    builder.addCase(deleteDayActivity.fulfilled, (state, action) => {
      const updatedDay = action.payload?.data;

      const index = state.dayPlans.findIndex(
        (d) => d._id === updatedDay?._id
      );

      if (index !== -1) {
        state.dayPlans[index] = updatedDay;
      }
    });


    builder.addCase(addDayActivity.fulfilled, (state, action) => {
      const updatedDay = action.payload?.data;

      const index = state.dayPlans.findIndex(
        (d) => d._id === updatedDay?._id
      );

      if (index !== -1) {
        state.dayPlans[index] = updatedDay;
      }
    });

    builder
      .addCase(calculatePackageOption.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        calculatePackageOption.fulfilled,
        (state, action) => {
          state.loading = false;
          state.calculation = action.payload?.data;
        }
      )
      .addCase(
        calculatePackageOption.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.payload;
        }
      );

    builder
      .addCase(updatepackage.fulfilled, (state, action) => {
        state.updateSuccess = true;

        const updated =
          action.payload?.data ||
          action.payload?.package;

        const index = state.packageList.findIndex(
          (p) => p._id === updated?._id
        );

        if (index !== -1)
          state.packageList[index] = updated;
      });


    builder
      .addCase(deletepackage.fulfilled, (state, action) => {
        state.packageList = state.packageList.filter(
          (p) => p._id !== action.payload
        );
      });
  },
});

export const { resetUpdateStatus } = packageSlice.actions;
export default packageSlice.reducer;